<template>
    <div>
        <HomeAdmin v-if="this.$store.state.perfil==='ADMIN'"></HomeAdmin>
        <HomeCandidato v-else></HomeCandidato>
    </div>
</template>

<script>
	import HomeAdmin from '../components/HomeAdmin.vue';
    import HomeCandidato from '../components/HomeCandidato.vue';
    import ApiService from '../service/ApiService';

	export default {

  		components: { HomeAdmin, HomeCandidato},

        data() {
            return {
                apiService: null,
            }
        },
        created() {
            this.apiService = new ApiService();
            this.apiService.getVersao().then((data) => {

                if (localStorage.getItem('versao') == undefined || localStorage.getItem('versao') != data.versao) {
                    localStorage.setItem('versao', data.versao);
                    location.reload(true);
                }

            });
		},

	}
</script>
